

import img1 from '../images/product-category/product-category-1.jpg'
import img2 from '../images/product-category/product-category-2.jpg'
import img3 from '../images/product-category/product-category-3.jpg'
import img4 from '../images/product-category/product-category-5.jpg'
import img5 from '../images/product-category/product-category-4.jpg'
const dataCategory = [
    {
        id: 1,
        img: img1,
        title: 'Shopping',
    },
    {
        id: 2,
        img: img2,
        title: 'Entertainment',
    },
    {
        id: 3,
        img: img3,
        title: 'E-Papers',
    },
    {
        id: 4,
        img: img4,
        title: 'Gaming',
    },
    {
        id: 5,
        img: img5,
        title: 'Discovery+',
    },

   
]

export default dataCategory;